import React, { Component } from 'react';
import { Route } from 'react-router'
import { withRouter } from 'react-router'

import { withTimerangeIntelligence } from '../../../shared/containers/containerTimerangeIntelligence'

import IntelligenceResultContent from './intelligenceResultContent'
import IntelligenceInTimeRangeContent from './intelligenceInTimeRangeContent'

import styles from './intelligenceResultContent.module.scss'

class IntellegenceResultWrapper extends Component {
  componentDidUpdate(prevProps) {
    const { match, onClearIntelligence } = this.props

    if (match.params.id !== prevProps.match.params.id)
      onClearIntelligence()
  }

  componentWillUnmount() {
    const { onClearIntelligence } = this.props

    onClearIntelligence()
  }
  
  render() {
    return (
      <div className={styles.intelligenceResultContent}>
        <div className={styles.container_viewTable}>
          <Route path='/cars/:id/intimerange' component={IntelligenceInTimeRangeContent} />
          <Route path='/cars/:id/inmoment' component={IntelligenceResultContent} />
        </div>
      </div>
    )
  }
}

export default withTimerangeIntelligence(withRouter(IntellegenceResultWrapper))